import React, { useEffect,useCallback } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { loadUserSuccess } from './Actions/userActions';
import ReactGA from "react-ga4"


import Register from './pages/Register/Register';
import Login from './pages/Login/Login';
import Landing from './pages/Landing';
import Profile from './pages/Profile';
import Payment from './pages/Payment';
import IDetail from './pages/IDetail';
import Search from './pages/Search';
import Applied from './pages/Applied';
import AboutUs from './pages/AboutUs';
import Blogs from './pages/Blogs';
import Faq from './pages/Faq';
import NoPage from './pages/NoPage';
import Internship from './pages/Internship';
import Admin from './pages/Admin';
import ViewApplication from './pages/ViewApplications';
import ViewInternshipDetails from './pages/ViewInternshipDetails';
import ChangePassword from './pages/ChangePassword';
import UpdateInternshipDetails from './pages/UpdateInternshipDetails';
import TransactionTable from './pages/TransactionTable';
import ResetPasswordPage from './pages/ResetPasswordPage';


const breakpoints = {
  base: '0px',
  sm: '320px',
  md: '900px',
  lg: '960px',
  xl: '1200px',
  '2xl': '1536px',
};

const theme = extendTheme({
  fonts: {
    heading: `'Poppins', sans-serif`,
    body: `'Poppins', sans-serif`,
  },
  breakpoints: breakpoints,
});

const App = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, isAdmin } = useSelector((state) => state.user);
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize("G-CPJQ915K5T"); // Initialize GA4
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]); // ✅ Correct use of useEffect

  const loadUser = useCallback(async (accessToken) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const res = await axios.get(`https://gyanbackend.aim4u.co.in/profile/`, config);
      const { email, id, is_admin } = res.data;
      dispatch(loadUserSuccess({ email, id, isAdmin: is_admin }));
    } catch (e) {
      console.error("Error loading user:", e);
    }
  }, [dispatch]);

  useEffect(() => {
    const accessToken = window.sessionStorage.getItem("accessToken");
    if (accessToken) {
      loadUser(accessToken);
    }
  }, [loadUser]);

  return (
    <ChakraProvider theme={theme}>
      
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={!isAuthenticated ? <Login /> : <Landing />} />
          <Route path="/register" element={!isAuthenticated ? <Register /> : <Landing />} />
          <Route path="/profile" element={isAuthenticated ? <Profile /> : <Login />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/details/:id" element={isAuthenticated ? <IDetail /> : <Login />} />
          <Route path="/search" element={<Search />} />
          <Route path="/internship" element={<Internship />} />
          <Route path="/applied" element={isAuthenticated ? <Applied /> : <Login />} />
          <Route path="/changePassword" element={isAuthenticated ? <ChangePassword /> : <Login />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="*" element={<NoPage />} />
          <Route path="/updateDetails/:id" element={<UpdateInternshipDetails />} />
          <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />

          {/* Admin Nested Routes */}
          {isAdmin && (
            <Route path="/admin" element={<Admin />}>
              
              
              <Route path="applications" element={<ViewApplication />} />
              <Route path="internshipDetails" element={<ViewInternshipDetails />} />
              <Route path="transactions" element={<TransactionTable />} />
              <Route path="upload-csv" element={<Admin />} />
            </Route>
          )}
        </Routes>
      
    </ChakraProvider>
  );
};

export default App;
